export default {
    login: {
        title: 'Login',
        description: 'Login'
    },
    home: {
        title: 'Homepage',
        description: 'Pagina dove potrete vedere statistiche, notifiche e altro'
    },
    customers: {
        title: 'Clienti',
        description: 'Panoramica completa dei clienti'
    },
    orders: {
        title: 'Ordini',
        description: 'Panoramica completa degli ordini'
    },
    quotes: {
        title: 'Preventivi',
        description: 'Panoramica completa dei preventivi'
    },
    products: {
        title: 'Prodotti',
        description: 'Panoramica completa dei prodotti'
    },
    areas: {
        title: 'Aree',
        description: 'Panoramica completa delle aree'
    },
    agents: {
        title: 'Agenti',
        description: 'Panoramica completa degli agenti'
    },
    provisions_schemes: {
        title: 'Schemi di Provvigione',
        description: 'Panoramica completa dei schemi di provvigione'
    },
    installer: {
        title: 'Installatori',
        description: 'Panoramica completa degli installatori'
    },
    notFound: {
        title: '404',
        description: 'Pagina non trovata'
    }
}